import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  UrlSegment,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { EntityCodes } from '@core/models/global-entities/global-enums';
import { AuthorizationService } from '@core/services/authorization.service';
import { isArray } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private router: Router,
    public authorizationService: AuthorizationService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return next.data && next.data.Actions && isArray(next.data.Actions)
      ? this.authorizationService.CheckAuth_MultiAction(
          next.queryParams,
          next.data.Actions
        )
      : this.authorizationService.CheckAuth_Action(next.data.ActionCode);
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authorizationService.CheckAuth_EntityCode(
      route.data.EntityCode
    );
  }
}
